import baseHttpService from "core/http/singleton/base";

import { GetImageParams } from "./paramsTypes";

import {
  getImageRes,
  getBankInformationRes,
  getBasicInformationRes,
  getEducationInformationRes,
  getMaritalInformationRes,
  getResidenceInformationRes,
  getWorkInformationRes,
  getLanguageInformationRes,
  getCertificationInformationRes,
  getWorkPerformanceRes,
  postFileRes,
  GroupItemDetailRes,
  getHistoryTimelineItem,
  personalInfoRes,
  getCertificationProfessionalRes,
} from "./resTypes";

import {
  getImageUrl,
  getBankInformationUrl,
  getBasicInformationUrl,
  getEducationInformationUrl,
  getMaritalInformationUrl,
  getResidenceInformationUrl,
  getWorkInformationUrl,
  getLanguageInformationUrl,
  getCertificationInformationUrl,
  getWorkPerformanceResultUrl,
  postFileUrl,
  getHistoryTimelineUrl,
  getHistoryDetailUrl,
  updatePersonalInformationUrl,
  getCheckEditableUrl,
  getCertificationProfessionalUrl,
} from "./urls";

export const getBankInformationApi =
  async (): Promise<getBankInformationRes> => {
    const res = await baseHttpService.get<getBankInformationRes>(
      getBankInformationUrl
    );
    if (!res || !res.data) throw new Error("Some thing wrong");
    return res.data;
  };

export const getBasicInformationApi =
  async (): Promise<getBasicInformationRes> => {
    const res = await baseHttpService.get<getBasicInformationRes>(
      getBasicInformationUrl
    );
    if (!res || !res.data) throw new Error("Some thing wrong");
    return res.data;
  };

export const getEducationInformationApi = async (): Promise<
  getEducationInformationRes[]
> => {
  const res = await baseHttpService.get<getEducationInformationRes[]>(
    getEducationInformationUrl
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getLanguageInformationApi =
  async (): Promise<getLanguageInformationRes> => {
    const res = await baseHttpService.get<getLanguageInformationRes>(
      getLanguageInformationUrl
    );
    if (!res || !res.data) throw new Error("Some thing wrong");
    return res.data;
  };

export const getCertificationInformationApi =
  async (): Promise<getCertificationInformationRes> => {
    const res = await baseHttpService.get<getCertificationInformationRes>(
      getCertificationInformationUrl
    );
    if (!res || !res.data) throw new Error("Some thing wrong");
    return res.data;
  };

export const getMaritalInformationApi =
  async (): Promise<getMaritalInformationRes> => {
    const res = await baseHttpService.get<getMaritalInformationRes>(
      getMaritalInformationUrl
    );
    if (!res || !res.data) throw new Error("Some thing wrong");
    return res.data;
  };

export const getResidenceInformationApi =
  async (): Promise<getResidenceInformationRes> => {
    const res = await baseHttpService.get<getResidenceInformationRes>(
      getResidenceInformationUrl
    );
    if (!res || !res.data) throw new Error("Some thing wrong");
    return res.data;
  };

export const getWorkInformationApi =
  async (): Promise<getWorkInformationRes> => {
    const res = await baseHttpService.get<getWorkInformationRes>(
      getWorkInformationUrl
    );
    if (!res || !res.data) throw new Error("Some thing wrong");
    return res.data;
  };

export const getImageApi = async (
  params: GetImageParams
): Promise<getImageRes> => {
  const res = await baseHttpService.get<getImageRes>(getImageUrl(params));
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getWorkPerformanceResultApi =
  async (): Promise<getWorkPerformanceRes> => {
    const res = await baseHttpService.get<getWorkPerformanceRes>(
      getWorkPerformanceResultUrl
    );
    if (!res || !res.data) throw new Error("Some thing wrong");
    return res.data;
  };

export const postFileApi = async (file: File): Promise<postFileRes> => {
  const formData = new FormData();

  formData.append("file", file);

  const res = await baseHttpService.post<postFileRes>(postFileUrl, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getHistoryTimelineApi = async (): Promise<
  getHistoryTimelineItem[]
> => {
  const res = await baseHttpService.get<getHistoryTimelineItem[]>(
    getHistoryTimelineUrl()
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getHistoryDetailApi = async (
  id: string
): Promise<GroupItemDetailRes> => {
  const res = await baseHttpService.get<GroupItemDetailRes>(
    getHistoryDetailUrl(id)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const postUpdatePersonalInfoApi = async (payload: {
  screenCode: string;
  body: any;
}): Promise<personalInfoRes> => {
  const { screenCode, body } = payload;
  const res = await baseHttpService.put<any>(
    updatePersonalInformationUrl(screenCode),
    body
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getCheckEditableApi = async (): Promise<boolean> => {
  const res = await baseHttpService.get<boolean>(getCheckEditableUrl("IP_002"));
  if (!res || typeof res.data !== "boolean")
    throw new Error("Some thing wrong");
  return res.data;
};

export const getCertificationProfessionalApi = async (): Promise<
  getCertificationProfessionalRes[]
> => {
  const res = await baseHttpService.get<getCertificationProfessionalRes[]>(
    getCertificationProfessionalUrl
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
